export class MongoAtlasRegionPlacement {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "provider",
            "baseName": "provider",
            "type": "string",
            "format": ""
        },
        {
            "name": "atlasRegionName",
            "baseName": "atlasRegionName",
            "type": "string",
            "format": ""
        },
        {
            "name": "priority",
            "baseName": "priority",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "electableNodeCount",
            "baseName": "electableNodeCount",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "readOnlyNodeCount",
            "baseName": "readOnlyNodeCount",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "analyticsNodeCount",
            "baseName": "analyticsNodeCount",
            "type": "number",
            "format": "int32"
        }
    ];
    static getAttributeTypeMap() {
        return MongoAtlasRegionPlacement.attributeTypeMap;
    }
    constructor() {
    }
}
